import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, Collapse, Grid, IconButton, Typography } from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';

import { FormInput } from '../../../components/hook-form/form-input.component';
import { FormSelectDynamic } from '../../../components/hook-form/form-select.dynamic.component';
import { stateApiKeyStore } from '../../../api/states-api-key-store';
import { municipalityApiKeyStore } from '../../../api/masters/municipality-api-key-store';
import { countyApiKeyStore } from '../../../api/county-api-key-store';
import { FormAutoCompleteMultiSelectDynamic } from '../../../components/hook-form/form-autocomplete-multi-select.dynamic.component';
import { FormFormattedInput } from '../../../components/hook-form/form-formatted-input.component';
import { ZIPCODE_FORMAT } from '../../../constants';
import { divisionApiKeyStore } from '../../../api/masters/division-api-key-store';
import { useFormContext } from 'react-hook-form';
import { FormAutoCompleteSelectDynamic } from '../../../components/hook-form/form-autocomplete-select.dynamic.component';
import { FormCheckbox } from '../../../components/hook-form/form-checkbox.component';
import { marketAreaApiKeyStore } from '../../../api/masters/market-area-api-key-store';
import { ConfirmDialogComponent } from './comfirm-dialog.component';
import { ProjectType } from '../../../models/project';
import { LotUpdateDialog } from './lot-update.dialog';

interface LocationForm {
  stateID?: any;
  project?: any;
  isEdit?: boolean;
  enableRequestField?: boolean;
  isRequestLoading?: boolean;
}
export const LocationForm = ({ stateID, project, isEdit, enableRequestField, isRequestLoading }: LocationForm) => {

  const { getValues, setValue } = useFormContext();
  const [passStateID, setStateID] = useState<any>(stateID ?? 0);
  const [expanded, setExpanded] = useState(true);
  const [countyChange, setCountyChange] = useState<any>(null);
  const [confirmDialog, setConfirmDialog] = useState<boolean>(false);
  const [actionValue, setActionValue] = useState<any>();
  const [actionType, setActionType] = useState<any>();
  const [stateIDData, setStateIDData] = useState<any>(project?.state)
  const [stateNameData, setStateNameData] = useState<any>(project?.stateName)
  const [countyData, setCountyData] = useState<any>(project?.county)
  const [marketAreaData, setMarketAreaData] = useState<any>(project?.marketAreas);
  const [municipalityData, setMunicipalityData] = useState<any>(project?.projectMunicipalities);

  const [changeType, setChangeType] = useState<any>();
  const [openLotConfirmDialog, setLotConfirmDialog] = useState<boolean>(false);

  const projectType = getValues('projectCommunityType');

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleCity = (cityValue: any) => {
    if (isEdit && !enableRequestField && projectType === ProjectType.ResidentialCommunity && cityValue !== null && cityValue !== "") {
      setChangeType({ type: "City", value: project?.city });
      setLotConfirmDialog(cityValue !== project?.city);
    }
  }

  const handleState = (stateValue: any) => {
    if (isEdit && !enableRequestField && projectType === ProjectType.ResidentialCommunity && stateValue !== null && stateValue !== "") {
      setChangeType({ type: "State", value: { stateID: stateIDData, stateName: stateNameData } });
      setLotConfirmDialog(stateValue?.stateID !== project?.state);
    }
    setStateID(stateValue ? stateValue?.stateID : 0);
    setValue('projectMunicipalities', []);
  };

  const handleZipcode = (value: any) => {
    if (isEdit && !enableRequestField && projectType === ProjectType.ResidentialCommunity && value !== null && value !== "") {
      setChangeType({ type: "Zipcode", value: project?.zipcode });
      setLotConfirmDialog(value !== project?.zipcode);
    }
  }

  const handleCounty = (value: any) => {
    if (isEdit && !enableRequestField && projectType === ProjectType.ResidentialCommunity && value !== null && value !== "") {
      setChangeType({ type: "County", value: countyData });
      setLotConfirmDialog(true);
    }
  };

  const handleMarketArea = (marketAreas: any) => {
    if (isEdit && !enableRequestField && projectType === ProjectType.ResidentialCommunity && marketAreas?.length > 0) {
      setChangeType({ type: "Market Area", value: marketAreaData });
      setLotConfirmDialog(true);
    }
  }

  const handleMunicipality = (municipalities: any[]) => {
    if (isEdit && !enableRequestField && projectType === ProjectType.ResidentialCommunity && municipalities?.length > 0) {
      setChangeType({ type: "Municipality", value: municipalityData });
      setLotConfirmDialog(true);
    }
    const hasSendInsReport: boolean = municipalities?.some((municipality: any) => municipality.sendInsReport === true);
    setValue('sendInsReport', hasSendInsReport ?? false);

    const isCoCRequired: boolean = municipalities?.some((municipality: any) => municipality.coCRequired === true);
    setValue('coCRequired', isCoCRequired ?? false);
  };

  useEffect(() => {
    if (getValues('projectMunicipalities')) {
      // handleMunicipality(getValues('projectMunicipalities'));
      const hasSendInsReport: boolean = getValues('projectMunicipalities')?.some(
        (municipality: any) => municipality.sendInsReport === true
      );
      setValue('sendInsReport', hasSendInsReport ?? false);
      // const isCoCRequired: boolean = getValues('projectMunicipalities')?.some(
      //   (municipality: any) => municipality.coCRequired === true
      // );
      // setValue('coCRequired', isCoCRequired ?? false);
    }
  }, [getValues('projectMunicipalities')]);

  const handleActionSubmit = (value: any, type: any) => {
    if (type == 'County') {
      setCountyChange(value);
      setValue('county', value);
    }
    setConfirmDialog(false);
  };

  const handleActionClosed = (type: string) => {
    if (type == 'County') {
      setValue('county', countyChange ? countyChange : project?.county ?? '');
    }
    setConfirmDialog(false);
  };

  const handleSubmitLotDialog = (actionData: any) => {
    if (actionData?.type == "State") {
      setStateIDData(getValues('state')?.stateID);
      setStateNameData(getValues('state')?.stateName)
      setValue('projectMunicipalities', []);
      setMunicipalityData([]);
    }
    if (actionData?.type == "County") {
      setCountyData(getValues('county'));
    }
    if (actionData?.type == "Market Area") {
      setMarketAreaData(getValues('marketAreas'));
    }
    if (actionData?.type == "Municipality") {
      setMunicipalityData(getValues('projectMunicipalities'));
    }
    setLotConfirmDialog(false);
    setChangeType(undefined);
  }

  const handleCloseLotDialog = (actionData: any) => {
    if (actionData?.type == 'City') {
      setValue('city', actionData?.value)
    }
    else if (actionData?.type == 'State') {
      setValue('state', { stateID: actionData?.value?.stateID ?? 0, stateName: actionData?.value?.stateName ?? '' });
      setStateID(actionData?.value?.stateID ?? 0);
      setValue('projectMunicipalities', municipalityData);
      setStateIDData(actionData?.value?.stateID ?? 0);
      setStateNameData(actionData?.value?.stateName ?? '')
    }
    else if (actionData?.type == "Zipcode") {
      setValue('zipcode', actionData?.value)
    }
    else if (actionData?.type == "County") {
      setValue('county', actionData?.value);
      setCountyData(actionData?.value);
    }
    else if (actionData?.type == "Market Area") {
      setValue('marketAreas', actionData?.value)
      setMarketAreaData(actionData?.value);
    }
    else if (actionData?.type == "Municipality") {
      setValue('projectMunicipalities', actionData?.value)
      setMunicipalityData(actionData?.value);
      const hasSendInsReport: boolean = actionData?.value?.some((municipality: any) => municipality.sendInsReport === true);
      setValue('sendInsReport', hasSendInsReport ?? false);

      const isCoCRequired: boolean = actionData?.value?.some((municipality: any) => municipality.coCRequired === true);
      setValue('coCRequired', isCoCRequired ?? false);
    }
    setLotConfirmDialog(false);
    setChangeType(undefined);
  }

  return (
    <>
      <Card elevation={0}>
        <CardHeader
          className="subHead"
          title={
            <Typography className="" variant="h3" color="textPrimary">
              LOCATION
            </Typography>
          }
          action={
            <IconButton onClick={handleExpandClick}>
              {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
            </IconButton>
          }
        />
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormInput name="street" label="Street Address" isParentLoading={isRequestLoading} />
              </Grid>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormInput
                  name="city"
                  label="City"
                  onBlur={handleCity}
                />
              </Grid>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormAutoCompleteSelectDynamic
                  name="state"
                  label="State"
                  parentLoading={isRequestLoading}
                  onChange={handleState}
                  getQueryKeyConfig={() => stateApiKeyStore.getStates()}
                  optionsValueKey="stateID"
                  optionsLabelKey="stateName"
                />
              </Grid>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormFormattedInput
                  name="zipcode"
                  label="Zip Code"
                  isParentLoading={isRequestLoading}
                  format={ZIPCODE_FORMAT}
                  onBlur={handleZipcode}
                />
              </Grid>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormSelectDynamic
                  name="county"
                  label="County"
                  onChange={handleCounty}
                  getQueryKeyConfig={() => countyApiKeyStore.getCounties()}
                  optionsValueKey="countyID"
                  optionsLabelKeys={['countyName']}
                />
              </Grid>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormAutoCompleteMultiSelectDynamic
                  name="marketAreas"
                  label="Market Areas"
                  onChange={handleMarketArea}
                  getQueryKeyConfig={() => marketAreaApiKeyStore.getMarketAreas()}
                  optionsValueKey="marketAreaID"
                  optionsLabelKey="marketAreaName"
                />
              </Grid>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormAutoCompleteMultiSelectDynamic
                  name="projectMunicipalities"
                  label="Municipality"
                  disabled={!passStateID}
                  onChange={handleMunicipality}
                  getQueryKeyConfig={() => municipalityApiKeyStore.getMunicipalityByStateID(passStateID)}
                  optionsValueKey="municipalityID"
                  optionsLabelKey="muncipalityName"
                />
              </Grid>
              <Grid item lg={4} sm={4} xl={4} xs={4}>
                <FormCheckbox disabled label="Send Inspection Report To Municipality" name="sendInsReport" />
              </Grid>


              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormCheckbox label="CoC Required" name="coCRequired" />
              </Grid>
              <Grid item lg={2} sm={2} xl={2} xs={2}>
                <FormCheckbox disabled label="Send CoC To Municipality" name="coCRequired" />
              </Grid>


              {/* <Grid item lg={4} sm={4} xl={4} xs={4}>
              <FormAutoCompleteMultiSelectDynamic
                name="projectDivisions"
                label="Division"
                getQueryKeyConfig={() => divisionApiKeyStore.getOfficeDivisions(getValues('office.officeID'))}
                optionsValueKey="divisionID"
                optionsLabelKey={'divisionName'}
              />
            </Grid> */}
            </Grid>
          </CardContent>
        </Collapse>
      </Card>
      <ConfirmDialogComponent
        openDialog={confirmDialog}
        value={actionValue}
        type={actionType}
        onSubmit={handleActionSubmit}
        onClosed={handleActionClosed}
      />
      {openLotConfirmDialog && (
        <LotUpdateDialog
          isOpen={openLotConfirmDialog}
          actionData={changeType}
          onClosed={handleCloseLotDialog}
          onSubmit={handleSubmitLotDialog}
        />
      )}
    </>
  );
};
